module.exports = __webpack_public_path__ + "static/media/insurance1.6ed0ec88.png";